export const CASES = {
    UPDATE_DEAL_VERSION: 'UPDATE_DEAL_VERSION',
    UPDATE_DEAL_VERSION_SEARCH_FORM: 'UPDATE_DEAL_VERSION_SEARCH_FORM',
    CLEAR_DEAL_VERSION: 'CLEAR_DEAL_VERSION',
};
